import { CEProjectAttributesBase } from './ce-project-attributes-base'


export class CEProjectAttributes extends CEProjectAttributesBase {

}